import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import client from '../client';
import { parseEnvelope } from '../envelope';

const clientTaxYearSchema = z.object({
  tax_year: z.number().int(),
  status: z.enum(['active', 'locked']),
  open_item_count: z.number().int().nonnegative(),
}).strict();

export const accountantClientSchema = z.object({
  grant_id: z.string().uuid(),
  owner_display_name: z.string(),
  entity_type: z.string().nullable(),
  tax_years: z.array(clientTaxYearSchema),
  last_opened_at: z.string().nullable(),
}).strict();

export const accountantClientsSchema = z.object({
  clients: z.array(accountantClientSchema),
}).strict();

export type AccountantClient = z.infer<typeof accountantClientSchema>;
export type AccountantClients = z.infer<typeof accountantClientsSchema>;

export function useAccountantClients() {
  return useQuery({
    queryKey: ['accountant-clients'],
    queryFn: async () => {
      const response = await client.get('/api/accountant/clients');
      return parseEnvelope(accountantClientsSchema, response.data).data;
    },
  });
}
